import React from 'react';
import Hero from './components/syllabus/Hero';
import Main from './components/syllabus/Main';

const Syllabus = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Syllabus;